import { createSelector } from '@reduxjs/toolkit';

import { refDataApi } from '../services/refData';
import { utcDateFormatter } from '../utils';
import { selectBusinessDetails } from './selectBusinessDetails';
import { selectState } from './selectState';

export const selectIndustries = createSelector(
  selectBusinessDetails,
  selectState,
  ({ coverStart }, state) => {
    if (!coverStart) return undefined;
    const result = refDataApi.endpoints.getIndustries.select({
      effectiveDate: utcDateFormatter(coverStart),
    })(state);
    return result.data?.industries.map((industry) => ({
      ...industry,
      ...(industry.industryCode === '06' && {
        industryValue: 'Accommodation',
      }),
    }));
  }
);
